export const enum X_CAMPAIGN_INTERACTION_TYPE {
  COMMENT = "comment",
  POST = "post",
  COMMENT_AND_FOLLOW_PARTNER = "comment_and_follow_partner",
  POST_AND_FOLLOW_PARTNER = "post_and_follow_partner",
}
